"use strict";

import angular from "angular";

import template from "./help-item-simple-topics.component.html";
import "./themes/help-item-simple-topics.component.scss";

class HelpItemSimpleTopicsComponent {
    constructor() {}

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

HelpItemSimpleTopicsComponent.$inject = [];

const name = "helpItemSimpleTopicsComponent";
const def = {
    bindings: {
        content: "<"
    },
    controller: HelpItemSimpleTopicsComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
